import {
  createTheme,
  CssBaseline,
  responsiveFontSizes,
  ThemeProvider,
} from '@mui/material';

export default function OwnThemeProvider({ children }) {
  const theme = responsiveFontSizes(
    createTheme({
      typography: {
        fontFamily: "'Libre Franklin', sans-serif",
      },
    }),
  );

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
}
